/**
 * 合作案例管理相关API接口
 */
import axios from '../axios'

const cooperationCaseAPI = {
  // 合作案例相关接口
  // 获取合作案例列表
  getCooperationCaseList(params) {
    return axios({
      url: '/cooperation-cases',
      method: 'GET',
      params
    })
  },
  
  // 获取单个合作案例详情
  getCooperationCase(id) {
    return axios({
      url: `/cooperation-cases/${id}`,
      method: 'GET'
    })
  },
  
  // 创建合作案例
  createCooperationCase(data) {
    return axios({
      url: '/cooperation-cases',
      method: 'POST',
      data
    })
  },
  
  // 更新合作案例
  updateCooperationCase(data) {
    return axios({
      url: `/cooperation-cases/${data.id}`,
      method: 'PUT',
      data
    })
  },
  
  // 删除合作案例
  deleteCooperationCase(id) {
    return axios({
      url: `/cooperation-cases/${id}`,
      method: 'DELETE'
    })
  }
}

export default cooperationCaseAPI